module.exports = __webpack_public_path__ + "img/home.f76cbbf7.png";